// Roulette result — single zero-padded number image (reference:
// .../static/admin/img/roulette/01.png), col-12 col-lg-7, desc col nahi
export default function RouletteResult({ detail }) {
  const win = detail?.win || detail?.result || detail?.desc || '';
  const num = String(win).replace(/\D/g, '').padStart(2, '0');

  return (
    <div className="row row5 worli-result">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center w-100">
            <div className="casino-result-cards">
              <div className="casino-result-cards-item">
                <img src={`https://wver.sprintstaticdata.com/v230/static/admin/img/roulette/${num}.png`} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
